<template>
  <div>
    <sidebar-item
      :link="{
        name: $t('sidebar.orders'),
        icon: 'tim-icons icon-delivery-fast',
        path: {name: 'supplier.order'},
      }" />
  </div>
</template>

<script>
export default {
  name: "sidebar",
  data(){
    return{

    }
  }
}
</script>